import { Box, Checkbox, FormControlLabel } from "@mui/material"
import type { ChangeEvent, FC } from "react"
import type { ControllerRenderProps } from "react-hook-form"
import { Controller, useFormContext } from "react-hook-form"

import type { OrderListFilter } from "@/graphql/codegen/graphql"

interface PurchaseOrderTestResultsFilterProps {
  onFilterChange: (name: keyof OrderListFilter, value?: boolean) => void
}

export const PurchaseOrderTestResultsFilter: FC<PurchaseOrderTestResultsFilterProps> = ({ onFilterChange }) => {
  const { control } = useFormContext<OrderListFilter>()

  const handleCheckboxChange = (
    field: ControllerRenderProps<OrderListFilter, "outstandingTestResults">,
    e: ChangeEvent<HTMLInputElement>
  ) => {
    field.onChange(e.target.checked)
    onFilterChange("outstandingTestResults", e.target.checked ? true : undefined)
  }

  return (
    <Box className='flex flex-col px-8 py-4'>
      <Controller
        name='outstandingTestResults'
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={<Checkbox checked={!!field.value} onChange={(e) => handleCheckboxChange(field, e)} />}
            label='Outstanding Test Results'
          />
        )}
      />
    </Box>
  )
}
